import { render, staticRenderFns } from "./PlansSmallCard.vue?vue&type=template&id=775c7fdc&scoped=true"
import script from "./PlansSmallCard.vue?vue&type=script&lang=js"
export * from "./PlansSmallCard.vue?vue&type=script&lang=js"
import style0 from "./PlansSmallCard.vue?vue&type=style&index=0&id=775c7fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c7fdc",
  null
  
)

export default component.exports